import React, { useEffect, useRef } from 'react'
import './modal.scss'

interface ModalProps {
	handleClose: any;
	children: any;
	open: boolean;
}

const Modal = (props: ModalProps) => {

	const ref = useRef(null) as any;

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (ref.current && !ref.current?.contains(event.target)) {
				props.handleClose();
			}
		}
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<>
			{props.open &&
				<>
					<div className="mentoria-modal-container"></div>
					<main className="mentoria-modal-content" ref={ref} data-testid="modal-content">
						<div className="mentoria-modal-content__close" onClick={props.handleClose}>x</div>
						{props.children}
					</main>
				</>
			}
		</>
	)
}

export default Modal